import { createPinia, type Store } from 'pinia'

export const pinia = createPinia()

// Every store created so far, so logout can reset them all.
export const stores = new Set<Store>()
pinia.use(({ store }) => {
  stores.add(store)
})
